const initialState = { annotations: [], pdfScale: 1 };

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case 'general.lightbox/SHOW_LIGHTBOX':
      return {
        images: action.images,
        active: action.active,
        annotations: [],
        pdfScale: 1,
      };
    case 'general.lightbox/HIDE_LIGHTBOX':
      return {};
    case 'general.lightbox/READ_ATTACHMENT_ANNOTATION_SUCCESS':
      return {
        ...state,
        annotations: action.response.data,
      };
    case 'general.lightbox/SET_PDF_SCALE':
      return {
        ...state,
        pdfScale: action.pdfScale,
      };
    default:
      return state;
  }
}
